import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CarCard } from '@perxis-auto/ui-kit/lib/components/CarCard';

import useCreditPreviewProgramPayment from '@/features/credit/hooks/useCreditPreviewProgramPayment';
import useCreditProgramPayment from '@/features/credit/hooks/useCreditProgramPayment';
import formatPrice from '@/utils/formatPrice';

import { CardPaymentProps } from './CardPayment.types';

/** Блок стоимости кредита */
function CardPayment({
  data,
  isLoading = false,
  label,
  value: customPayment,
  prefix,
  postfix,
}: CardPaymentProps) {
  const { credit } = data?.data || {};

  const { t } = useTranslation();

  const carId = data?.id;

  const creditProgramPayment = useCreditProgramPayment(carId);
  const creditPreviewProgramPayment = useCreditPreviewProgramPayment(carId);

  // Приоритет отображения стоимости кредита.
  // 1. Переданное значение компонента
  // 2. Значение объекта автомобиля (свойство credit)
  // 3. Ежемесячный платеж выбранной кред. программы
  // 4. Ежемесячный платеж стартовой кред. программы
  const payment =
    customPayment ?? credit ?? creditProgramPayment ?? creditPreviewProgramPayment;

  const formattedPayment = useMemo(() => {
    const resolvedPayment = payment ? `${Math.round(Number(payment))}/${t('month')}` : '';
    return formatPrice(resolvedPayment, prefix, postfix, t);
  }, [payment, prefix, postfix, t]);

  if (isLoading) {
    return <CarCard.PaymentSkeleton />;
  }

  return (
    <CarCard.Payment
      label={label ?? t('card.payment')}
      value={formattedPayment}
      hidden={!formattedPayment}
    />
  );
}

export default CardPayment;
